var map = {
	"./img_1.jpg": 66,
	"./img_2.jpg": 965,
	"./img_3.jpg": 832,
	"./img_4.jpg": 667,
	"./img_5.jpg": 206,
	"./img_6.jpg": 553,
	"./img_7.jpg": 508
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;